import type { ReactNode } from 'react'

// App-level grid: 232px sidebar, 56px top bar. Sidebar and TopBar are passed in so a route
// that renders without chrome can do so. Vendored from the Admin Console, plus ONE addition:
// `rail`, which narrows the sidebar to icons so the main column takes the width (chrome.css).
export function Shell({
  sidebar,
  topbar,
  children,
  rail = false,
}: {
  sidebar: ReactNode
  topbar: ReactNode
  children: ReactNode
  rail?: boolean
}) {
  return (
    <div className={rail ? 'app app--rail' : 'app'} data-rail={rail ? 'true' : undefined}>
      {sidebar}
      {topbar}
      <main className="main">{children}</main>
    </div>
  )
}
